export default [
  {
    title: 'Tổng quan',
    group: 'apps',
    icon: 'fa-tachometer-alt',
    name: 'Dashboard',
    roleId: 1,
  },
  {
    title: 'Hashtag đơn hàng',
    group: 'apps',
    icon: 'fa-tag',
    name: 'hashtag-don-hang',
    roleId: 32
  },
  {
    title: 'Báo cáo',
    group: 'bao-cao',
    icon: 'fa-chart-line',
    name: 'Report',
    roleId: 4,
    items: [
      {
        title: 'Công nợ',
        name: 'bao-cao-cong-no',
        component: 'bao-cao-cong-no',
        reportRoleId: 8
      },
      // {
      //   title: 'Doanh thu',
      //   name: 'bao-cao-doanh-thu',
      //   component: 'bao-cao-doanh-thu',
      //   reportRoleId: 8
      // },
      {
        title: 'Lợi nhuận mua hàng',
        name: 'thong-ke-loi-nhuan-dat-hang',
        component: 'thong-ke-loi-nhuan-dat-hang',
        reportRoleId: 1,
      },
      // { 
      //   title: 'Phí mua hàng',
      //   name: 'thong-ke-phi-mua-hang',
      //   component: 'thong-ke-phi-mua-hang',
      //   reportRoleId: 2,
      // },
      {
        title: 'Phí vận chuyển',
        name: 'thong-ke-phi-van-chuyen',
        component: 'thong-ke-phi-van-chuyen',
        reportRoleId: 4
      },
      {
        title: 'Chênh lệch tỷ giá',
        name: 'thong-ke-tien-te',
        component: 'thong-ke-tien-te',
        reportRoleId: 8,
      },
      {
        title: 'Thống kê nạp tiền',
        name: 'bao-cao-nap-tien',
        component: 'bao-cao-nap-tien',
        reportRoleId: 8
      },
      {
        title: 'Hoa hồng đơn hoàn thành',
        name: 'thong-ke-hoa-hong-nhan-vien',
        component: 'thong-ke-hoa-hong-nhan-vien',
        reportRoleId: 2
      },
      {
        title: 'Doanh thu tổng',
        name: 'bao-cao-tong-hop',
        component: 'bao-cao-tong-hop',
        reportRoleId: 8
      },
    ]
  },
  {
    title: 'Thống kê',
    group: 'thong-ke',
    icon: 'fa-chart-line',
    name: 'Analytic',
    roleId: 4,
    items: [
      {
        title: 'Tiền cọc',
        name: 'thong-ke-tien-coc',
        component: 'thong-ke-tien-coc',
        reportRoleId: 8
      },
      {
        title: 'Tiền mua hàng',
        name: 'thong-ke-tien-mua-hang',
        component: 'thong-ke-tien-mua-hang',
        reportRoleId: 1,
      },
      {
        title: 'Đơn hàng',
        name: 'thong-ke-don-hang',
        component: 'thong-ke-don-hang',
        reportRoleId: 8
      },
      {
        title: 'Hoa hồng CSKH',
        name: 'commission_analytic',
        component: 'commission_analytic',
        reportRoleId: 2
      },
      {
        title: 'Tiền mặc cả',
        name: 'thong-ke-tien-mac-ca',
        component: 'thong-ke-tien-mac-ca',
        reportRoleId: 8,
      },
      {
        title: 'Phí dịch vụ',
        name: 'thong-ke-phi-dich-vu',
        component: 'thong-ke-phi-dich-vu',
        reportRoleId: 8,
      },
      {
        title: 'Nhập kho VN',
        name: 'thong-ke-nhap-kho-vn',
        component: 'thong-ke-nhap-kho-vn',
        reportRoleId: 8,
      },
      {
        title: 'Xuất kho VN',
        name: 'thong-ke-xuat-kho-vn',
        component: 'thong-ke-xuat-kho-vn',
        reportRoleId: 8,
      },
      {
        title: 'Lợi nhuận',
        name: 'thong-ke-loi-nhuan',
        component: 'thong-ke-loi-nhuan',
        reportRoleId: 8,
      },
      {
        title: 'Doanh thu kho',
        name: 'thong-ke-doanh-thu-kho',
        component: 'thong-ke-doanh-thu-kho',
        reportRoleId: 8,
      },
    ]
  },
  {
    title: 'Đơn hàng',
    group: 'don-hang',
    icon: 'fa-shopping-cart',
    name: 'Orders',
    roleId: 1,
    items: [
      {
        title: 'Mua hộ',
        group: 'apps',
        icon: 'fa-shopping-cart',
        name: 'OrderList',
        component: 'OrderList',
        roleId: 32,
        badge: false,
        children: [
          { name: 'orderdetail', title: 'Chi tiết mua hộ', component: 'OrderDetail' }
        ]
      },
      {
        title: 'Ký gửi',
        group: 'apps',
        icon: 'fa-cart-plus',
        name: 'Deposit',
        component: 'Deposit',
        roleId: 32,
        badge: false,
        children: [
          { name: 'DepositDetail', title: 'Chi tiết ký gửi', component: 'DepositDetail' }
        ]
      },
      {
        title: 'Thanh toán hộ',
        group: 'apps',
        icon: 'fa-credit-card',
        name: 'PayServiceList',
        component: 'PayServiceList',
        roleId: 64,
        badge: false,
        children: [
          { name: 'PayServiceDetail', title: 'Chi tiết thanh toán hộ', component: 'PayServiceDetail' }
        ]
      },
      {
        title: 'Cập nhật vận đơn',
        group: 'apps',
        icon: 'fa-credit-card',
        name: 'OrderTransactionCode',
        component: 'OrderTransactionCode',
        roleId: 32,
        badge: false
      },
      {
        title: 'Khiếu nại',
        group: 'apps',
        icon: 'fa-exclamation-circle',
        name: 'Complain',
        component: 'Complain',
        roleId: 8,
        children: [
          { name: 'ComplainDetail', title: 'Chi tiết khiếu nại', component: 'ComplainDetail' }
        ]
      }
    ]
  },
  {
    title: 'Kế toán',
    group: 'ke-toan',
    icon: 'fa-chart-line',
    name: 'Accountant',
    roleId: 128,
    items: [
      {
        title: 'Thanh toán',
        component: 'PayOrderList',
        roleId: 1
      },
      // {
      //   title: 'Kiểm soát đơn hàng',
      //   component: 'AccountantOrder',
      //   reportRoleId: 16
      // },
      {
        title: 'Tài chính',
        name: 'bao-cao-tai-chinh',
        component: 'bao-cao-tai-chinh',
        reportRoleId: 16,
      },
      // {
      //   title: 'Luồng thu chi (¥)',
      //   component: 'AccountantCumulationList',
      //   roleId: 1
      // },
      // {
      //   title: 'Luồng thu chi (₫)',
      //   component: 'AccountantCumulationVNDList',
      //   roleId: 1
      // },
      {
        title: 'Shop hoàn tiền KN',
        component: 'TuiKuanList',
        reportRoleId: 16
      },
    ]
  },  
  {
    title: 'Khách hàng',
    group: 'apps',
    icon: 'fa-user',
    name: 'CustomerList',
    roleId: 8,
    children: [
      { name: 'CustomerDetail', title: 'Chi tiết khách hàng', component: 'CustomerDetail'  }
    ]
  },
  {
    title: 'Nạp tiền',
    group: 'apps',
    icon: 'fa-wallet',
    name: 'RechargeNew',
    roleId: 16
  },
  {
    title: 'Rút tiền',
    group: 'apps',
    icon: 'fa-wallet',
    name: 'WithdrawHistory',
    roleId: 8   
  },
  {
    title: 'Mã vận đơn',
    cn_title: '运单号',
    group: 'apps',
    icon: 'fa-cubes',
    name: 'Transaction',
    roleId: 512
  },
  {
    title: 'Thu chi kho TQ',
    cn_title: '收支对照表',
    group: 'apps',
    icon: 'fa-info-circle',
    name: 'StoreReportList',
    roleId: 2048
  }, 
  {
    title: 'Nhập kho TQ',
    cn_title: '中国入库',
    group: 'apps',
    icon: 'fa-warehouse',
    name: 'StoreManager',
    roleId: 1024
  },
  {
    title: 'Bao hàng',
    cn_title: '货物管理',
    group: 'apps',
    icon: 'fa-box',
    name: 'BigPackage',
    roleId: 2048
  }, 
  {
    title: 'Nhập kho VN',
    group: 'apps',
    icon: 'fa-store',
    name: 'StoreManagerVN',
    roleId: 256
  },
  {
    title: 'Chờ xuất kho VN',
    group: 'apps',
    badge: true,
    icon: 'fa-dolly-flatbed',
    name: 'Deliverable',
    roleId: 256
  },
  {
    title: 'Đã xuất kho VN',
    group: 'apps',
    badge: true,
    icon: 'fa-check-square',
    name: 'Exported',
    roleId: 256
  },
  {
    title: 'Cài đặt',
    group: 'cai-dat',
    icon: 'fa-cogs',
    name: 'Setting',
    roleId: 2,
    items: [
      {
        name: 'Configuration', 
        title: 'Cấu hình chung', 
        component: 'Configuration'
      },
      {
        name: 'BankInfoList', 
        title: 'TK ngân hàng', 
        component: 'BankInfoList', 
        children: [
          { name: 'BankInfoDetail', title: 'Chi tiết ngân hàng', component: 'BankInfoDetail' }
        ]
      },
      {
        name: 'FlagList', 
        title: 'Hashtag', 
        component: 'FlagList', 
        children: [
          { name: 'FlagDetail', title: 'Chi tiết hashtag', component: 'FlagDetail' }
        ]
      },
      {
        title: 'Kho hàng TQ',
        name: 'ChinaStoreList',
        component: 'ChinaStoreList', 
        children: [
          { name: 'ChinaStoreDetail', title: 'Chi tiết kho TQ', component: 'ChinaStoreDetail' }
        ]
      },
      {
        title: 'Kho hàng VN',
        name: 'WarehouseList',
        component: 'WarehouseList', 
        children: [
          { name: 'WarehouseDetail', title: 'Chi tiết kho', component: 'WarehouseDetail' }
        ]
      },
      {
        title: 'Nhân viên',
        name: 'StaffList',
        component: 'StaffList', 
        children: [
          { name: 'StaffDetail', title: 'Chi tiết nhân viên', component: 'StaffDetail' }
        ]
      },
      {
        name: 'FeeBuyList', 
        title: 'Phí mua hàng', 
        component: 'FeeBuyList', 
        children: [
          { name: 'FeeBuyDetail', title: 'Chi tiết phí mua hàng', component: 'FeeBuyDetail' }
        ]
      },
      {
        name: 'PricesList', 
        title: 'Bảng giá vận chuyển', 
        component: 'PricesList', 
        children: [
          { name: 'PricesDetail', title: 'Chi tiết bảng giá', component: 'PricesDetail' }
        ]
      },
      // {
      //   name: 'FeeWeightList', 
      //   title: 'Phí cân nặng', 
      //   component: 'FeeWeightList', 
      //   children: [
      //     { name: 'FeeWeightDetail', title: 'Chi tiết phí cân nặng', component: 'FeeWeightDetail' }
      //   ]
      // },
      // {
      //   name: 'FeeVolumeList', 
      //   title: 'Phí khối', 
      //   component: 'FeeVolumeList', 
      //   children: [
      //     { name: 'FeeVolumeDetail', title: 'Chi tiết phí khối', component: 'FeeVolumeDetail' }
      //   ]
      // },
      {
        name: 'FeeCheckList', 
        title: 'Phí kiểm đếm', 
        component: 'FeeCheckList', 
        children: [
          { name: 'FeeCheckDetail', title: 'Chi tiết phí kiểm đếm', component: 'FeeCheckDetail' }
        ]
      },
      {
        name: 'FeeGuaranteeList', 
        title: 'Phí bảo hiểm', 
        component: 'FeeGuaranteeList', 
        children: [
          { name: 'FeeGuaranteeDetail', title: 'Chi tiết phí bảo hiểm', component: 'FeeGuaranteeDetail' }
        ]
      },
      {
        name: 'FeeReinforceList', 
        title: 'Phí gia cố', 
        component: 'FeeReinforceList', 
        children: [
          { name: 'FeeReinforceDetail', title: 'Chi tiết phí gia cố', component: 'FeeReinforceDetail' }
        ]
      },
      { 
        name: 'CustomerLevel', 
        title: 'Khách hàng thân thiết', 
        component: 'CustomerLevel',
        children: [
          { name: 'CustomerLevelDetail', title: 'Chi tiết level', component: 'CustomerLevelDetail' }
        ]
      }
    ]
  },
  // {
  //   title: 'Nhập liệu',
  //   group: 'apps',
  //   icon: 'input',
  //   name: 'DataManager',
  // },  
];
